import React, { useState } from "react";
import {
  ScaleFade,
  Box,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
} from "@chakra-ui/react";
import { AiOutlineUpload } from "react-icons/ai";
import { useModal } from "hooks/useModal";
import { __TradeAgreementFil } from "request/configuration/__TradeAgreement";
import AlertError from "components/Alerts/AlertError";
import { useSelector } from "react-redux";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import { isString } from "utils/type-check-utils";

const ImportTradeAgreement = () => {
  const [file, setFile] = useState(null);
  const [isOpen, closeModal] = useModal();
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [openAlert] = AlertErrorAlert();
  const token = useSelector((state) => state.auth.dataUser.token);
  const [inputKey, setInputKey] = useState(Date.now()); // Nuevo estado para actualizar la clave del componente Input

  const handleCloseAlert = () => {
    closeModal();
    setAlertMessage("");
  };

  const handleAddItem = async () => {
    if (!file) {
      openAlert({
        title: "Error",
        description: "Por favor, selecciona un archivo.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await __TradeAgreementFil(token, formData);
      if (res.data.status.code === 200) {
        openAlert("Archivo cargado exitosamente.", "success");
      } else {
        openAlert(res.data.status.message, "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const { files } = e.target;
    const extensionOptions = [
      '.doc',
      '.docx',
      '.pdf',
      '.png',
      '.jpg',
      '.jpeg',
      '.gif',
      '.bmp',
      '.xls',
      '.xlsx',
      '.xlsm',
      'image/png',
      'image/*',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/pdf',
      'application/vnd.ms-excel'
    ]
  

    const getFileExtension = files[0].name.split(".").pop();
    const fileExtension = isString(getFileExtension)
      ? getFileExtension.toLowerCase()
      : getFileExtension || "";

    const isValidExtension = extensionOptions.includes(`.${fileExtension}`);
    if (!isValidExtension) {
      const fileName = files[0].name;
      return openAlert(
        `El archivo ${fileName} no es un tipo de archivo permitido.`,
        "error"
      );
    }

    setFile(e.target.files[0]);
  };

  const handleRemoveFile = () => {
    setFile(null);
    setInputKey(Date.now()); // Actualizar la clave del componente Input para que el evento onChange se dispare nuevamente
  };

  return (
    <Box p={4}>
      <FormControl>
        <FormLabel htmlFor="fileSelect">Importar acuerdo comercial</FormLabel>

        <Flex alignItems="center">
          <Input
            key={inputKey} // Agregar la clave al componente Input
            onChange={handleFileChange}
            type="file"
            accept=".xlsx, .xls, .csv"
            id="fileSelect"
            display="none"
          />
          <label htmlFor="fileSelect">
            <Button as="span" leftIcon={<AiOutlineUpload />} disabled={loading}>
              Seleccionar archivo
            </Button>
          </label>
          {file && (
            <Flex alignItems="center" ml={4}>
              <Text mr={2}>{file.name}</Text>
              <Button size="sm" onClick={handleRemoveFile} disabled={loading}>
                Eliminar
              </Button>
            </Flex>
          )}
          <Button
            onClick={handleAddItem}
            colorScheme="blue"
            disabled={!file || loading}
            isLoading={loading}
            ml={4}
          >
            Subir
          </Button>
        </Flex>
      </FormControl>
      <ScaleFade in={isOpen}>
        <AlertError alertMessage={alertMessage} closeAlert={handleCloseAlert} />
      </ScaleFade>
    </Box>
  );
};

export default ImportTradeAgreement;
